import { render, staticRenderFns } from "./FilterCustomSort.vue?vue&type=template&id=5a557307&scoped=true&"
import script from "./FilterCustomSort.vue?vue&type=script&lang=js&"
export * from "./FilterCustomSort.vue?vue&type=script&lang=js&"
import style0 from "./FilterCustomSort.vue?vue&type=style&index=0&id=5a557307&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a557307",
  null
  
)

export default component.exports